<script setup lang="ts">
import { UIButton } from '@groover-dev/groover-ui'

import { useGetDatoUrlForLink } from '~/composables/useGetDatoUrlForLink'

import { useUserStore } from '~/stores/user'

import { provideJoinWaitList } from '~/api-core/Subscription/WaitList'

import type { JoinWaitListCtaFragment } from '~/graphql/generated'

type Props = JoinWaitListCtaFragment

const props = withDefaults(defineProps<Props>(), {
  text: '',
  joinedText: '',
  ctaType: 'primary',
  url: '',
})

const { t } = useI18n()

const {
  IS_LOGGED_IN,
  KIND: USER_KIND,
  is_on_subscription_wait_list: IS_ON_WAIT_LIST,
} = storeToRefs(useUserStore())
const { SET: SET_USER } = useUserStore()

const { coreFetch } = useProvideCoreFetch()
const { getUrl, isExternalLink: checkIfExternal } = useGetDatoUrlForLink()

const isExternalLink = computed(() => Boolean(checkIfExternal(props.url)))
async function joinWaitList() {
  if (!IS_LOGGED_IN.value || USER_KIND.value !== 'band') return

  await provideJoinWaitList(coreFetch)()
  // eslint-disable-next-line camelcase
  SET_USER({ is_on_subscription_wait_list: true })

  if (props.url) return navigateTo(getUrl(props.url))
}
</script>

<template>
  <UIButton
    :text="
      IS_ON_WAIT_LIST
        ? joinedText || t('subscription.waitlist.joined')
        : text || t('subscription.waitlist.join')
    "
    :icon-left-name="IS_ON_WAIT_LIST ? 'fa6-solid:check' : undefined"
    :variant="ctaType === 'primary' ? 'primary' : 'outlined'"
    :class="{
      'tw-bg-orange-500': ctaType === 'primary',
      '!tw-border-orange-500 !tw-text-orange-500': ctaType === 'outlined',
    }"
    size="large"
    :to="url ? getUrl(url) || undefined : undefined"
    :target="isExternalLink ? '_blank' : undefined"
    :disabled="IS_ON_WAIT_LIST"
    @click="joinWaitList"
  />
</template>
